import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavController, NavParams, LoadingController, ToastController, ModalController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { ImagePipe } from 'src/app/pipes/image/image';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { GrupoProvider } from 'src/app/services/grupo/grupo';


@Component({
  selector: 'app-grupo-check-pessoa-detalhes',
  templateUrl: './grupo-check-pessoa-detalhes.page.html',
  styleUrls: ['./grupo-check-pessoa-detalhes.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule,
    NomenclaturaPipe,
    ReactiveFormsModule
  ],
})
export class GrupoCheckPessoaDetalhesPage implements OnInit {
  responsavel: any = {};
  pessoa: any = {};
  isMenor: boolean = false;
  validations_form: FormGroup;
  idReuniao: any = "";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public grupoProvider: GrupoProvider,
    public loadingController: LoadingController,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
  ) {
    this.pessoa = this.navParams.get('pessoa');
    this.responsavel = this.navParams.get('responsavel');
    this.isMenor = this.navParams.get('isMenor');
    this.idReuniao = this.navParams.get('idReuniao');

    this.validations_form = this.formBuilder.group({
      observacao: new FormControl('', Validators.nullValidator),
    });
  }

  ngOnInit() {
  }

  onSubmit(check: { observacao: any; }) {
    let isCheckin = !this.pessoa.checkin ? true : false;

    this.grupoProvider.check(this.pessoa.id, this.pessoa.entidade, this.pessoa.idEntidade, check.observacao, (this.responsavel ? this.responsavel.id : null), isCheckin, this.idReuniao)
      .subscribe(async data => {
        const message = isCheckin ? this.translate.instant('Checkin realizado com sucesso!') : this.translate.instant('Checkout realizado com sucesso!');

        let tipo = '1';
        if (isCheckin && (this.pessoa.entidade == 'grupoxpessoa' || this.pessoa.entidade == 'grupoxvisitante')) {
          tipo = this.pessoa.entidade == 'grupoxpessoa' ? '1' : '2';
          let data = { idProjeto: this.idReuniao, tipo: tipo, pessoa: this.pessoa };
          this.grupoProvider.salvarParticipante(data).subscribe((data) => {

          });
        }

        const toast = await this.toastCtrl.create({
          message: message,
          duration: 3000
        });

        toast.present();

        this.modalCtrl.dismiss(true);

      });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

}
